export const verificationQueryKeys = {
  consents: (id?: string) => ['consents', id] as const,
  status: (id?: string) => ['status', id] as const,
  redirect: (id?: string) => ['redirect', id] as const,
  aspsp: (id?: string) => ['aspsp', id] as const,
  aspspList: (id?: string) =>
    [...verificationQueryKeys.aspsp(id), 'list'] as const,
  aspspOpenBankingUrl: (id?: string) =>
    [...verificationQueryKeys.aspsp(id), 'openBankingUrl'] as const,
  partnerLogo: (id?: string) => ['partner-logo', id] as const,
  retryMessage: (id?: string) => ['retryMessage', id] as const,
  callback: (param?: string) => ['callback', param] as const,
  serverRedirect: (param: string | undefined) =>
    ['server-redirect', param] as const,
  wssUrl: (id?: string) => ['wss-url', id] as const,
};
